// extracted by mini-css-extract-plugin
export default {"container":"WpV8oylnbb9rx5_Wd_OR"};